<section class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12 mb-1 mb-md-3">
                <h4 class="text-black profile-table-title"><strong>Phone</strong></h4>
            </div>
            <div class="col-xl-6 col-md-12">
                <table class="table-edit">
                    <thead class="table-head">
                    <th class="max-width-150">Phone</th>
                    <th>Type</th>
                    <th class="profile-last-col width-50">Actions</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let phone of model.phones" [class.isFavorite]="phone.primary">
                            <td class="profile-row max-width-150">
                                <i *ngIf="phone.primary" class="fa fa-star"></i>
                                <span>{{ phone.phoneNumber }}</span>
                            </td>
                            <td>{{ phone.phoneType.description }}</td>
                            <td class="actions">
                                <i (click)="edit(phone)" class="edit-btn">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 640 640">
                                        <title></title>
                                        <g id="icomoon-ignore"></g>
                                        <path fill="#cc0000" d="M611.313 28.686c-17.981-17.98-41.886-27.882-67.313-27.882-25.428 0-49.333 9.902-67.313 27.882l-408 408c-1.653 1.653-2.924 3.648-3.723 5.846l-64 176c-2.125 5.842-0.673 12.386 3.723 16.781 3.053 3.055 7.144 4.687 11.315 4.687 1.833 0 3.682-0.314 5.465-0.963l176-64c2.197-0.8 4.193-2.070 5.846-3.724l408-408c17.98-17.98 27.883-41.886 27.883-67.314s-9.902-49.333-27.883-67.313zM183.196 546.177l-140.443 51.069 51.070-140.442 354.177-354.177 89.373 89.373-354.177 354.177zM588.687 140.686l-28.687 28.687-89.373-89.373 28.687-28.687c11.936-11.936 27.806-18.509 44.686-18.509s32.75 6.574 44.687 18.51c11.936 11.936 18.51 27.806 18.51 44.686s-6.575 32.75-18.51 44.686z"></path>
                                    </svg>
                                </i>
                                <i  (click)="!phone.primary? delete(phone) : false" [ngClass]="{'fa-trash-o': !phone.primary, 'fa-primary-contact': phone.primary}" class="fa"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 mt-3">
                <div>
                    <div *ngIf="!isFormVisible">
                        <a class="profile-add-more"
                           (click)="create()"
                           id="profile-Phone-Btn">
                            Add Phone
                        </a>
                    </div>
                    <form #form="ngForm" *ngIf="isFormVisible" class="row mt-3 d-flex align-items-center">
                        <div class="col-12 col-md-6 col-sm-6">
                            <div class="d-flex flex-column form-group py-0">
                                <label class="form-control-label">Addl. Phone</label>
                                <input type="text"
                                       placeholder="(888) 910-1101"
                                       name="phone-{{i}}"
                                       [(ngModel)]="editModel.phoneNumber"
                                       #phoneControl="ngModel"
                                       maxlength="20"
                                       required
                                       class="form-control"
                                       [dropSpecialCharacters]="false"
                                       mask="(000) 000-0000"
                                       pattern="^([\(]{1}[0-9]{3}[\)]{1}[ |\-]{0,1}|^[0-9]{3}[\-| ])?[0-9]{3}(\-| ){1}[0-9]{4}$">
                                <div class="form-control-error"
                                     *ngIf="!phoneControl.valid && (phoneControl.touched || state.isSubmitted)">
                                    <ul>
                                        <li *ngIf="phoneControl?.errors?.required">Phone is required.</li>
                                        <li *ngIf="phoneControl?.errors?.maxlength">Must be 20 characters long.</li>
                                        <li *ngIf="phoneControl?.errors?.pattern">Invalid format.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-3 col-sm-6">
                            <div class="d-flex flex-column form-group py-0">
                                <label class="form-control-label">Type</label>
                                <select class="form-control"
                                        name="phoneType-{{i}}"
                                        [(ngModel)]="editModel.phoneType.constituentPhoneTypeID"
                                        #phoneTypeControl="ngModel"
                                        required
                                        id="profile-Phone-Type">
                                    <option class="form-check" *ngFor="let option of dictData.PhoneType" [ngValue]="option.cmgmtPhoneTypeId">
                                        {{ option.description }}
                                    </option>
                                </select>
                                <div class="form-control-error"
                                     *ngIf="!phoneTypeControl.valid && (phoneTypeControl.touched || state.isSubmitted)">
                                    <ul>
                                        <li *ngIf="phoneTypeControl?.errors?.required">Phone Type is required.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <div class="d-flex align-items-center pt-4">
                                <label class="form-control-label custom-control custom-checkbox" for="profile-Phone-Primary">
                                    <input class="form-check-input custom-control-input"
                                           type="checkbox"
                                           id="profile-Phone-Primary"
                                           [checked]="editModel.primary"
                                           (change)="editModel.primary = !editModel.primary">
                                    <span class="custom-control-label"></span>
                                    <span class="custom-control-description">Set As Primary</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-12">
                            <button type="button"
                                    class="btn btn-primary mr-3"
                                    (click)="save()">Save</button>
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    (click)="cancel()">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
